import ReadOnlyAnalyzer from "./ReadOnlyAnalyzer";

/**
 * Überprüft, ob ein Eingabefeld Readonly ist.
 * Sucht dazu in dem Eingabefeld und in seinen direkten Parents nach Tags "readonly". 
 * Das erste Tag, dass bei der Suche von unten nach oben in der Hierachie vorhanden
 * ist, liefert den Ergebniswert der Funktion.
 * Insbesondere könnten also "readonly=true"-Elemente Attribute mit "readonly=false" enthalten.
 * In diesem Fall wird die Funktion zurueckliefern, dass das Attribut veränderbar ist.
 *
 * Jede Instanz von FormField verwaltet eine Instanz von ReadOnlyAnalyzer. 
 * Applikationen können Vererbungen von ReadOnlyAnalyzer bereitstellen und diese in eine
 * FormField einhängen, um komplexere readonly-Bedingungen zu
 * implementieren. Beispielsweise können so readOnly-Bedingungen erstellt werden,
 * wie "Wenn dies und das Eingabefeld den und den Wert hat, dann sei ReadOnly"
 */

export default class XMLRDBReadOnlyAnalyzer extends ReadOnlyAnalyzer {
  constructor() {
    super("XMLRDBReadOnly");
    this.leseansicht = false;
  }

  isReadOnly(dataAttribute) {
    if (this.leseansicht) return true;
    if (!dataAttribute) return false;
    return dataAttribute.metadata.isReadOnly(dataAttribute.dataElement);
  }
  
  setIsLeseansicht() {
    this.leseansicht = true;
  }
}

XMLRDBReadOnlyAnalyzer.singleton = new XMLRDBReadOnlyAnalyzer();